module.exports = __webpack_public_path__ + "img/6_134.efaaae2d.png";